export function parishAddressLine(row: {
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}) {
  return [row.address, row.city, row.state, row.zip].filter(Boolean).join(", ");
}
